import { produce } from 'immer';
import { omit, set } from 'lodash';

import { UpdateInternalBannerTemplateId } from '../../../actions/bannersEdit/internal/updateInternalBannerTemplateId';
import { generateNewTemplateVars } from '../../../service/InternalBannerHelpers/InternalBannerHelpers';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function updateInternalBannerTemplateId(
    state: EditInternalBannersState,
    action: UpdateInternalBannerTemplateId
): EditInternalBannersState {
    return produce(state, draft => {
        const { bannerId, value } = action;

        if (draft.banners[bannerId].errors) {
            set(
                draft.banners[bannerId],
                'errors',
                omit(draft.banners[bannerId].errors, ['templateVars', 'templateId'])
            );
        }

        draft.banners[bannerId].templateId = value;
        draft.banners[bannerId].templateVars = generateNewTemplateVars(
            draft,
            draft.banners[bannerId].campaign.id,
            value,
            draft.banners[bannerId].templateVars
        );
    });
}
